module.exports = __webpack_public_path__ + "media/fonts/SFProText-Bold-45784509db84409f4325afeee71c31c7.svg";